import computeTagName from '../../../../../../utils/computeTagName';
import computeClassName from '../../../../../../utils/computeClassName';
import Container from '../../../../Container';
import SearchForms from './SearchForms';
import SearchResults from './SearchResults';

const constants = Object.freeze({
  TAG_DEFAULT: 'main',
  CLASSNAME_BASE: 'bg-cc-secondary text-cc-secondary-contrast flex flex-col'
});

const propsDefaults = Object.freeze({
  tag: constants.TAG_DEFAULT
});


export default function PartnerSearchMain(
  {
    tag = propsDefaults.tag,
    className = ''
  }
) {

  const ComputedTagName = computeTagName(tag, constants.TAG_DEFAULT);
  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);

  return (
    <ComputedTagName className={computedClassName}>
      <Container tag="div" className="flex-grow flex flex-col">
        <SearchForms/>
        <SearchResults className="flex-grow flex flex-col"/>
      </Container>
    </ComputedTagName>
  );
}
